__turbopack_context__.v({
  "approvalType": "RequestApprovalModal-module__pQBFaq__approvalType",
  "body": "RequestApprovalModal-module__pQBFaq__body",
  "characterCount": "RequestApprovalModal-module__pQBFaq__characterCount",
  "characterCountWrapper": "RequestApprovalModal-module__pQBFaq__characterCountWrapper",
  "footer": "RequestApprovalModal-module__pQBFaq__footer",
  "modalContent": "RequestApprovalModal-module__pQBFaq__modalContent",
  "toggleSwitch": "RequestApprovalModal-module__pQBFaq__toggleSwitch",
  "warningAlertContainer": "RequestApprovalModal-module__pQBFaq__warningAlertContainer",
});
